/**
 * @desc 获取所有的品类
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductCategroyResponseDtoRpc>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/productCategroy/getAllCategroys`, {
      method: "GET",

      ...options,
    }),
  );
}
